import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import { formatDate, todayIso } from '@platform/core/lib/format';
import { recordNumber } from '@platform/engine/views/recordNumber';
import type { IAnalyticsDueProps } from './IAnalyticsDueProps';

/** «Термін протягом 7 днів» (прототип v4): номер («101», як у списках), назва, дата терміну (прострочені — помаранчеві); без записів — «Цього тижня термінів немає.». */
export function AnalyticsDue({ records, dueKey, lang, onOpen }: IAnalyticsDueProps) {
  const { t } = useTranslation();
  const today = todayIso();
  return (
    <section className="an-card">
      <div className="an-card__title">{t('modBody.dash.due7')}</div>
      <div className="an-due">
        {records.map((r) => {
          const due = dueKey ? String(r.values[dueKey] ?? '').slice(0, 10) : '';
          return (
            <button key={r.id} type="button" className="an-due__row" onClick={() => onOpen(r)}>
              <span className="an-due__code" title={r.display}>{recordNumber(r)}</span>
              <span className="an-due__title">{r.title}</span>
              <span className={cx('an-due__date', due < today && 'is-late')}>{formatDate(due, lang)}</span>
            </button>
          );
        })}
        {!records.length && <div className="an-due__none">{t('modBody.dash.noDue')}</div>}
      </div>
    </section>
  );
}
